import { SporsmalType } from '../../types/generated-types';
import { CurrentSporsmal } from '../reducer/current-steg';
import { KredtittkortnummerSporsmal } from '../reducer/sporsmalsflyt-types';

export const PARTIAL_KREDITTKORTNUMMER_ERROR = 'Ugyldig kredittkortnummer';

export type InputGroupName = 'one' | 'two' | 'three';
type InputGroupIndex = 0 | 1 | 3;
type InputGroupLength = 2 | 4;

export interface InputGroup {
    index: InputGroupIndex;
    length: InputGroupLength;
}

export const inputGroup: Record<InputGroupName, InputGroup> = {
    one: { index: 0, length: 4 },
    two: { index: 1, length: 2 },
    three: { index: 3, length: 4 },
};

export interface CurrentKredittkortnummerSporsmal {
    type: SporsmalType.Kredittkortnummer;
    sporsmal: KredtittkortnummerSporsmal;
    kredittkortnummer?: string;
}

export type BesvartKredittkortnummerSporsmal = CurrentKredittkortnummerSporsmal;

export const isKredittkortSporsmal = (sporsmal: CurrentSporsmal): sporsmal is BesvartKredittkortnummerSporsmal =>
    sporsmal.type === SporsmalType.Kredittkortnummer;

export const inputGroupValue = (kredittkortnummer: string, length: InputGroupLength): string =>
    kredittkortnummer.substring(0, length);

export const formatKredittkortnummer = (
    updatedSvar: string,
    kredittkortnummer: string,
    inputGroup: InputGroup,
): string => {
    const updatedSvarDigitsOnly = updatedSvar.replace(/\D/g, '');
    const numberGroupsDigitsOnly = kredittkortnummer.replace(/\*/g, '').split('-');

    if (numberGroupsDigitsOnly.length === 4) {
        numberGroupsDigitsOnly[inputGroup.index] = inputGroupValue(updatedSvarDigitsOnly, inputGroup.length);

        return `${numberGroupsDigitsOnly[0]}-${numberGroupsDigitsOnly[1]}**-****-${numberGroupsDigitsOnly[3]}`;
    }

    const svarNumberGroup = updatedSvarDigitsOnly.substring(0, inputGroup.length);

    switch (inputGroup.index) {
        case 0:
            return `${svarNumberGroup}---`;
        case 1:
            return `-${svarNumberGroup}--`;
        case 3:
            return `---${svarNumberGroup}`;
        default:
            return '';
    }
};

export const updateKredittkortnummerSvar = (
    currentSporsmal: CurrentSporsmal,
    updatedSvar: string,
    inputGroup: InputGroup,
): CurrentSporsmal => {
    if (isKredittkortSporsmal(currentSporsmal)) {
        return {
            ...currentSporsmal,
            kredittkortnummer: formatKredittkortnummer(updatedSvar, currentSporsmal.kredittkortnummer, inputGroup),
        };
    }
    return currentSporsmal;
};

export const validatePartialKredittkortnummer = (kredittkortnummer: string): boolean => {
    return /^\d{4}-\d{2}\*{2}-\*{4}-\d{4}$/.test(kredittkortnummer);
};
